import { Button } from "@/components/ui/button";

const billingHistory = [
  {
    id: 1,
    subscription: "Professional Plan",
    payment_date: "September 8, 2025",
    amountPaid: "$100",
    paymentMethod: "Credit Card",
  },
  {
    id: 2,
    subscription: "Professional Plan",
    payment_date: "September 8, 2025",
    amountPaid: "$100",
    paymentMethod: "Credit Card",
  },
  {
    id: 3,
    subscription: "Professional Plan",
    payment_date: "September 8, 2025",
    amountPaid: "$100",
    paymentMethod: "Credit Card",
  },
  {
    id: 4,
    subscription: "Professional Plan",
    payment_date: "September 8, 2025",
    amountPaid: "$100",
    paymentMethod: "Credit Card",
  },
];

export default function Billing() {
  return (
    <div className="flex flex-col gap-5 rounded-lg bg-white p-5">
      <div className="flex flex-row items-center justify-between">
        <div className="space-y-2">
          <div className="text-lg leading-5 font-bold -tracking-wide text-neutral-950">
            Billing History
          </div>
          <div className="text-xs leading-3 text-neutral-500">
            Manage how you pay for your subscription
          </div>
        </div>
      </div>

      {/* Header */}
      <div className="grid grid-cols-5 gap-4 px-4 py-3">
        <div className="text-xs font-medium tracking-wide text-neutral-500 uppercase">
          Subscription
        </div>
        <div className="text-xs font-medium tracking-wide text-neutral-500 uppercase">
          Payment Date
        </div>
        <div className="text-xs font-medium tracking-wide text-neutral-500 uppercase">
          Amount Paid
        </div>
        <div className="text-xs font-medium tracking-wide text-neutral-500 uppercase">
          Payment Method
        </div>
        <div className="flex justify-end text-xs font-medium tracking-wide text-neutral-500 uppercase"></div>
      </div>

      {/* Email List */}
      <div className="flex flex-col gap-2">
        {billingHistory.map((billing) => (
          <div
            key={billing.id}
            className="grid grid-cols-5 items-center gap-4 rounded-lg px-4 py-4 transition-colors hover:bg-neutral-100/80"
          >
            <div className="truncate text-sm font-bold text-neutral-950">
              {billing.subscription}
            </div>
            <div className="truncate text-sm text-neutral-950">
              {billing.payment_date}
            </div>
            <div className="text-sm text-neutral-950">{billing.amountPaid}</div>

            <div className="truncate text-sm text-neutral-950">
              {billing.paymentMethod}
            </div>
            <div className="flex justify-end text-sm font-medium text-neutral-950">
              <Button
                variant="minimal"
                className="bg-neutral-100 hover:bg-neutral-100/80"
              >
                View Receipt
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
